/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import getDashboardLayout from './get-dashboard-layout';

export default (state) => get(getDashboardLayout(state), 'name', '');
